module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch3_20210921031149_T.37e8417d.jpg";